import React, { lazy, Suspense, useContext } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_CONFIG from './config/api';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Templates from './pages/Templates';
import TemplateForm from './pages/TemplateForm';
import Chat from './pages/Chat';
import Users from './pages/Users';
import SetupAdmin from './pages/SetupAdmin';
import ApiModels from './pages/ApiModels';
const RSSPage = lazy(() => import('./pages/RSSPage'));
const RSSSettingsPage = lazy(() => import('./pages/RSSSettingsPage'));

// Components
import Navbar from './components/Navbar';

// Context
import { AuthProvider } from './context/AuthContext';
import AuthContext from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

// Настройка базового URL axios из конфигурации
axios.defaults.baseURL = API_CONFIG.getBaseURL();

// Add auth token to requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function App() {
  const location = useLocation();
  const isRSSRoute = location.pathname.startsWith('/rss');

  return (
    <AuthProvider>
      <ThemeProvider>
        <div className="App">
          <Navbar />
          <main className={`${isRSSRoute ? 'container-fluid px-3 px-xl-4' : 'container'} py-4`}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register/:token" element={<Register />} />
              <Route path="/setup-admin" element={<SetupAdmin />} />
              <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
              <Route path="/templates/new" element={<ProtectedRoute><TemplateForm /></ProtectedRoute>} />
              <Route path="/templates/edit/:id" element={<ProtectedRoute><TemplateForm /></ProtectedRoute>} />
              <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
              <Route path="/chat/:id" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
              <Route
                path="/rss"
                element={(
                  <ProtectedRoute>
                    <Suspense fallback={<div className="py-4">Загрузка RSS...</div>}>
                      <RSSPage />
                    </Suspense>
                  </ProtectedRoute>
                )}
              />
              <Route
                path="/rss/settings"
                element={(
                  <DirectorRoute>
                    <Suspense fallback={<div className="py-4">Загрузка RSS Settings...</div>}>
                      <RSSSettingsPage />
                    </Suspense>
                  </DirectorRoute>
                )}
              />
              <Route path="/users" element={<DirectorRoute><Users /></DirectorRoute>} />
              <Route path="/models" element={<DirectorRoute><ApiModels /></DirectorRoute>} />
              <Route path="/" element={<Navigate to="/templates" replace />} />
            </Routes>
          </main>
          <ToastContainer position="bottom-right" autoClose={3000} />
        </div>
      </ThemeProvider>
    </AuthProvider>
  );
}

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Director Route component
const DirectorRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const { user } = useContext(AuthContext);
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (user && user.role !== 'director') {
    return <Navigate to="/templates" replace />;
  }
  
  return children;
};

// Admin Route component (больше не используется - можно удалить)
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const { user } = useContext(AuthContext);
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (user && user.role !== 'director') {
    return <Navigate to="/templates" replace />;
  }
  
  return children;
};

export default App; 
